import { getToken } from '../../utils/auth';
import { apiSlice } from '../../reducers/index';

export const useServiceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSectionsData: builder.query<any, any>({
      query: ({ districtId }) => {
        return {
          url: `/fact-sheet-responses/districts/${districtId}/section-details`,
          method: 'GET',
          headers: getToken(),
        };
      },
      providesTags: ['getSections'],
    }),
    getProgressData: builder.query<any, any>({
      query: ({ districtId }) => {
        return {
          url: `/fact-sheet-responses/progress/${districtId}`,
          method: 'GET',
          headers: getToken(),
        };
      },
      providesTags: ['getSections'],
    }),
  }),
});

export const { useGetSectionsDataQuery, useGetProgressDataQuery } = useServiceApi;
